<template>
  <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="9" md="4">
        <WriteoffFormsSearchForm
          :inventory="true"
          @submit="search()"
        />
      </v-col>
      <v-col cols="auto" style="display: flex; flex-direction: column;">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyInventoryFormsNew'})"
        >
          Vnos
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <!-- <th>
                  Vrstna št.
                </th> -->
                <th>
                  Datum
                </th>
                <th>
                  Komentar
                </th>
                <th>
                  Začetno stanje
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(inventoryForm, index) in inventories"
                :key="inventoryForm.id"
              >
                <!-- <td>{{inventoryForm.label}}</td> -->
                <!-- <td>#{{index+1}}</td> -->
                <td>{{inventoryForm.date | sloDate}}</td>
                <td>{{inventoryForm.comment || 'Brez komentarja'}}</td>
                <td><ActiveIcon :value="inventoryForm.is_reset" /></td>
                <td class="text-right">
                  <ButtonActionEdit @click="$router.push({ name: 'MyCompanyInventoryFormsEdit', params: { id: inventoryForm.id } })" />
                  <ButtonActionPrint @click="printInventoryForm(inventoryForm.id)" />
                  <ButtonActionDelete @click="showDeleteAcceptanceFormModal = true; deleteAcceptanceForm = inventoryForm" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje inventure"
      text="Ali ste prepričani, da želite izbrisati inventar? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteAcceptanceFormModal"
      @confirmed="remove(deleteAcceptanceForm)"
    />
  </div>
  <div v-else>
    {{'garara'}}
    <AppSpinner />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ButtonActionPrint from '@/components/ButtonActionPrint'
import ActiveIcon from '@/components/ActiveIcon'
import WriteoffFormsSearchForm from '@/components/WriteoffFormsSearchForm'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionPrint,
    ActiveIcon,
    WriteoffFormsSearchForm
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      inventories: [],
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null
    }
  },
  methods: {
    ...mapActions('inventoryForms', ['loadItems', 'deleteItem', 'setFilters']),
    printInventoryForm (idwoform) {
      let routeData = this.$router.resolve({ name: 'MyCompanyInventoryFormPreview', params: { id: idwoform } })
      window.open(routeData.href, '_blank')
    },
    remove (item) {
      this.deleteItem(item.id)
        .then(() => {
          this.doLoadItems(this.$store.state.inventoryForms.filters)
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    search (form) {
      const filters = {}
      if (form) {
        if (form.startDate) {
          filters.dateFrom = form.startDate
        }
        if (form.endDate) {
          filters.dateTo = form.endDate
        }
        if (form.label) {
          filters.label = form.label
        }
        if (form.deliveryDocument) {
          filters.deliveryDocument = form.deliveryDocument
        }
        if (form.includeArticles) {
          filters.includeArticles = form.includeArticles === 1 ? true : false
        }
        this.setFilters(filters)
      }
      this.doLoadItems(filters)
    },
    doLoadItems (filters) {
      this.loadItems({ filters })
        .then(res => {
          this.inventories = objectToArray(res)
          this.asyncDataStatus_fetched()
        })
    },
    /* searchLastFilters () {
      const filters = this.$store.state.inventoryForms.filters
      if (filters) {
        this.doLoadItems(filters)
      }
    } */
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.search()
      // this.asyncDataStatus_fetched()
    }
  }
}
</script>
